module.exports = __webpack_public_path__ + "static/media/ball.e2c74090.png";